import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import Swal from "sweetalert2"
import { productStartDeleted } from "../../../../actions/products"
import { Search } from "../../../ui/Search"
import { Select } from "../../../ui/Select"
import { ProductCardStock } from "./ProductCardStock"



export const ProductsAllScreen = () => {
  const [search, setSearch] = useState('')
  const [currentSelected, setcurrentSelected] = useState('')
  
  const { productsDB } = useSelector( state => state)
  const dispatch = useDispatch()
  let dataSelected = []
 
  if( currentSelected !== 'all' && currentSelected !== "destacado"){

     dataSelected =  productsDB.filter( itemFiltrado => itemFiltrado.type.toUpperCase().includes( currentSelected.toUpperCase() ) )
      
    }else if(currentSelected == 'destacado'){

      dataSelected = productsDB.filter( itemFiltrado => itemFiltrado.destacado === true )     

    }else{
      dataSelected = productsDB
  }

  const dataFiltered = dataSelected.filter( itemFiltrado => itemFiltrado.nombre.toUpperCase().includes( search.toUpperCase() ) )

const handleAllDelete = () =>{
  Swal.fire({
    title: 'Estas por eliminar TODOS los productos',
    icon: 'warning',
    showDenyButton: true,
    // showCancelButton: true,
    confirmButtonText: 'Eliminar',
    denyButtonText: `Cancelar`,
}).then((result) => {
  /* Read more about isConfirmed, isDenied below */
  if (result.isConfirmed) {

    

  productsDB.map( item => 
    
    
    dispatch(productStartDeleted(item))
    
    )
      Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Productos Eliminados',
          showConfirmButton: false,
          timer: 3000
        })
   
  } else if (result.isDenied) {
      Swal.fire({
          position: 'center',
          icon: 'info',
          title: 'El producto NO ah sido eliminado',
          showConfirmButton: false,
          timer: 1000
        })
  }
})

}

  return (

    <div className="row _products">
      <h5 className="col-12 col-lg-2 title-panel">Todos los Productos</h5>
      <div className='col-9 col-sm-6 col-lg-3'>
        <Search search={ search } setSearch={ setSearch } setcurrentSelected={setcurrentSelected}/>
      </div>
      <div className='col-4 col-sm-6 col-lg-3'>
          <Select currentSelected={ currentSelected }  setcurrentSelected={ setcurrentSelected } />
      </div>
      <div className="col-2 btn_red " onClick={handleAllDelete}>
        borrar todo
      </div>
      <div className="_productCardStock row ">
        {
          dataFiltered.map(product =>
              <ProductCardStock key={product.id+ "adm"} item={product} />
            )
        }
      </div>
    
    </div>
  )
}
